import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL || process.env.REACT_APP_API_URL || "http://localhost:8000";
export const API = `${BASE}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const STATUS_OPTIONS = [
  { value: "randevu_bekliyor", label: "Randevu Bekliyor", pill: "status-appt" },
  { value: "evrak_bekliyor", label: "Evrak Bekliyor", pill: "status-doc" },
  { value: "sonuc_bekliyor", label: "Sonuç Bekliyor", pill: "status-pending" },
  { value: "vize_onaylandi", label: "Vize Onaylandı", pill: "status-approved" },
  { value: "vize_red", label: "Vize Red", pill: "status-rejected" },
  { value: "iptal", label: "İptal", pill: "status-cancel" },
];

export const statusLabel = (v) => STATUS_OPTIONS.find((s) => s.value === v)?.label || v;
export const statusPill = (v) => STATUS_OPTIONS.find((s) => s.value === v)?.pill || "status-appt";
export const fmtEUR = (n) => `€${(Number(n) || 0).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const fmtTL = (n) => `₺${(Number(n) || 0).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
